@file:OptIn(InternalResourceApi::class)

package studio.oddpods.cauce.feature.payments.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.ResourceItem
import org.jetbrains.compose.resources.StringResource

private const val MD: String =
    "composeResources/studio.oddpods.cauce.feature.payments.generated.resources/"

internal val Res.string.payments_amount_label: StringResource by lazy {
      StringResource("string:payments_amount_label", "payments_amount_label", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10, 49),
      ))
    }

internal val Res.string.payments_date_label: StringResource by lazy {
      StringResource("string:payments_date_label", "payments_date_label", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 60, 47),
      ))
    }

internal val Res.string.payments_error_amount_invalid: StringResource by lazy {
      StringResource("string:payments_error_amount_invalid", "payments_error_amount_invalid", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 108, 69),
      ))
    }

internal val Res.string.payments_error_load_patients: StringResource by lazy {
      StringResource("string:payments_error_load_patients", "payments_error_load_patients", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 178, 72),
      ))
    }

internal val Res.string.payments_error_load_sessions: StringResource by lazy {
      StringResource("string:payments_error_load_sessions", "payments_error_load_sessions", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 251, 68),
      ))
    }

internal val Res.string.payments_error_patient_required: StringResource by lazy {
      StringResource("string:payments_error_patient_required", "payments_error_patient_required", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 320, 71),
      ))
    }

internal val Res.string.payments_error_save_failed: StringResource by lazy {
      StringResource("string:payments_error_save_failed", "payments_error_save_failed", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 392, 70),
      ))
    }

internal val Res.string.payments_error_session_required: StringResource by lazy {
      StringResource("string:payments_error_session_required", "payments_error_session_required", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 463, 67),
      ))
    }

internal val Res.string.payments_form_title: StringResource by lazy {
      StringResource("string:payments_form_title", "payments_form_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 531, 47),
      ))
    }

internal val Res.string.payments_method_cash: StringResource by lazy {
      StringResource("string:payments_method_cash", "payments_method_cash", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 579, 40),
      ))
    }

internal val Res.string.payments_method_label: StringResource by lazy {
      StringResource("string:payments_method_label", "payments_method_label", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 620, 49),
      ))
    }

internal val Res.string.payments_method_mercadopago: StringResource by lazy {
      StringResource("string:payments_method_mercadopago", "payments_method_mercadopago", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 670, 51),
      ))
    }

internal val Res.string.payments_method_transfer: StringResource by lazy {
      StringResource("string:payments_method_transfer", "payments_method_transfer", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 722, 52),
      ))
    }

internal val Res.string.payments_no_sessions: StringResource by lazy {
      StringResource("string:payments_no_sessions", "payments_no_sessions", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 775, 44),
      ))
    }

internal val Res.string.payments_notes_label: StringResource by lazy {
      StringResource("string:payments_notes_label", "payments_notes_label", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 820, 36),
      ))
    }

internal val Res.string.payments_patient_label: StringResource by lazy {
      StringResource("string:payments_patient_label", "payments_patient_label", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 857, 46),
      ))
    }

internal val Res.string.payments_save: StringResource by lazy {
      StringResource("string:payments_save", "payments_save", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 904, 41),
      ))
    }

internal val Res.string.payments_session_item: StringResource by lazy {
      StringResource("string:payments_session_item", "payments_session_item", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 946, 53),
      ))
    }

internal val Res.string.payments_session_label: StringResource by lazy {
      StringResource("string:payments_session_label", "payments_session_label", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1000, 42),
      ))
    }

internal val Res.string.payments_session_pending: StringResource by lazy {
      StringResource("string:payments_session_pending", "payments_session_pending", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1043, 60),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainString0Resources(map: MutableMap<String, StringResource>) {
  map.put("payments_amount_label", Res.string.payments_amount_label)
  map.put("payments_date_label", Res.string.payments_date_label)
  map.put("payments_error_amount_invalid", Res.string.payments_error_amount_invalid)
  map.put("payments_error_load_patients", Res.string.payments_error_load_patients)
  map.put("payments_error_load_sessions", Res.string.payments_error_load_sessions)
  map.put("payments_error_patient_required", Res.string.payments_error_patient_required)
  map.put("payments_error_save_failed", Res.string.payments_error_save_failed)
  map.put("payments_error_session_required", Res.string.payments_error_session_required)
  map.put("payments_form_title", Res.string.payments_form_title)
  map.put("payments_method_cash", Res.string.payments_method_cash)
  map.put("payments_method_label", Res.string.payments_method_label)
  map.put("payments_method_mercadopago", Res.string.payments_method_mercadopago)
  map.put("payments_method_transfer", Res.string.payments_method_transfer)
  map.put("payments_no_sessions", Res.string.payments_no_sessions)
  map.put("payments_notes_label", Res.string.payments_notes_label)
  map.put("payments_patient_label", Res.string.payments_patient_label)
  map.put("payments_save", Res.string.payments_save)
  map.put("payments_session_item", Res.string.payments_session_item)
  map.put("payments_session_label", Res.string.payments_session_label)
  map.put("payments_session_pending", Res.string.payments_session_pending)
}
